import { store } from '@redux/store'
import { t } from './translation'
import { PLATFORM } from '@const'
import * as utils from '@utils'

export function ComposePfSubPfId(platformId, subPlatformId) {
    return platformId + '_' + subPlatformId
}

export function ComposePublicPfSubPfId(pfID) {
    return ComposePfSubPfId(pfID, PLATFORM.PUBLIC_SUB_PF_ID)
}

// SortPlatform - move dev platform at bottom
export function SortPlatform(a_pf_sub_pf_id, b_pf_sub_pf_id) {
    const pfSubPfMap = store.getState().dataService?.pfSubPfMap ?? null

    if (!pfSubPfMap) return 1

    const devPlatformRegEx = /正測|測試|TEST|dev|Beta|預設子平台/

    const defaultVal = (pf_sub_pf_id) => (pf_sub_pf_id.indexOf('public') > -1 ? '共用' : '')
    const a_name = pfSubPfMap?.[a_pf_sub_pf_id]?.name ?? defaultVal(a_pf_sub_pf_id)
    const b_name = pfSubPfMap?.[b_pf_sub_pf_id]?.name ?? defaultVal(b_pf_sub_pf_id)

    return devPlatformRegEx.test(a_name) && !devPlatformRegEx.test(b_name)
        ? 1
        : !devPlatformRegEx.test(a_name) && devPlatformRegEx.test(b_name) && a_name.localeCompare(b_name) === 1
        ? -1
        : a_name.localeCompare(b_name)
}

/** 排序 中>英>測試 */
export function convertSort({ source, sortKey = 'name', replaceText = false }) {
    const devPlatformRegEx = /正測|測試|TEST|DEV|BETA|預設子平台/
    const sourceList = Array.isArray(source) ? source : Object.values(source)
    const reg = /^\[/i
    const resultList = sourceList.sort(function(a, b) {
        const a_name = replaceText
            ? a[sortKey]
                  .trim()
                  .toUpperCase()
                  .replace(reg, '')
            : a[sortKey].trim().toUpperCase()
        const b_name = replaceText
            ? b[sortKey]
                  .trim()
                  .toUpperCase()
                  .replace(reg, '')
            : b[sortKey].trim().toUpperCase()
        return devPlatformRegEx.test(a_name) && !devPlatformRegEx.test(b_name)
            ? 1
            : !devPlatformRegEx.test(a_name) && devPlatformRegEx.test(b_name)
            ? -1
            : a_name.localeCompare(b_name, 'zh-Hant')
    })
    return resultList
}

export function GeneratePfSubPfName(pfSubPfID) {
    const pfSubPfMap = store.getState().dataService?.pfSubPfMap ?? null

    if (!pfSubPfMap) return 'Failed'

    return pfSubPfID
        ? pfSubPfMap[pfSubPfID]
            ? `${t('Platform.' + pfSubPfMap[pfSubPfID].pf_id)} - ${pfSubPfMap[pfSubPfID].name}`
            : 'Unknown'
        : t('noPfSubPf')
}

export function IsPfAccount(account) {
    const pfAccountRegEx = /^(ac|acphp|acthb|acvnd|pbdt|phkd|pidr|pinr|pmmk|pmmko|pmxn|pmyr|pmyrh|pnpr|pnrl|pbrl|pthbt|ptnd|ptry|pusd|pusdt|pvndo|pkes|pngn|pamd|ppkr|pzar|ze|paud|pjpy|pkrw|pxin|plkr|ptzs|pgbp|peur|pclp|petb|pidro|prub|pcad|dmyr|dmyrh|dphp|dinr|dbdt|plak|plako|paed|pbnd|pars|pghs|pegp|pkhr|pkhro|pcop|ppgk|ppen|maud|dmaud|guest|6u657).*_.*/
    return pfAccountRegEx.test(account)
}

export function getPfID(pfSubPfID) {
    const pfSubPfMap = store.getState().dataService?.pfSubPfMap ?? null

    return pfSubPfMap?.[pfSubPfID]?.['pf_id'] ?? null
}

/**
 * 站台(幣別)排序
 * @param {Array} platformList 
 * @param {String} key 
 * @returns {Array}
 */
export function sortPlatform(platformList, key) {
    const commonList = Object.assign([],[...PLATFORM.PLATFORM_SORT]).reverse()
    platformList.sort((a,b)=>{
        const a_value = a[key] || a
        const b_value = b[key] || b
        const a_index = commonList.indexOf(a_value)
        const b_index = commonList.indexOf(b_value)
        return a_index > b_index ? -1 : a_index < b_index ? 1 : 0
    })
    return platformList
}

export function getSubPlatformName(subPlatformId) {
    const pfSubPfMap = store.getState().dataService?.pfSubPfMap ?? null
    return pfSubPfMap?.[subPlatformId]?.['name'] ?? null
}
/** 
 * 取得目前有開啟的幣別
 */
export function getEnablePlatform() {
    const pfSubPfMap = utils.deepCopy(store.getState().dataService.pfSubPfMap)
    const pfList = [] // 整理幣別(站台)類別
    Object.entries(pfSubPfMap).forEach(([pfSubPfId, elem]) => {
        if (!store.getState().auth.isSuperUser && pfSubPfId === 'ze_ze') return
        if (!pfList.includes(elem.pf_id)) pfList.push(elem.pf_id)
    })
    const sortPfList = utils.sortPlatform(pfList) // 幣別(站台)排序

    return sortPfList
}

export function getPlatformsNotSupportEvents() {
    const pfSubPfMap = utils.deepCopy(store.getState().dataService.pfSubPfMap)
    const platformsList = Object.keys(pfSubPfMap).reduce((accumulator, currentValue) => {
        if (!pfSubPfMap[currentValue].support_event) {
            return accumulator.concat(pfSubPfMap[currentValue].pf_sub_pf_id)
        }
        return accumulator
    }, [])
    return platformsList
}